import { ROW_TYPES } from '../TableConsts';
import FullColSpanRow from './FullColSpanRow';
import LoadMoreRow from './LoadMoreRow';

const SpecialRowTypes = ({ row }) => {
  const { rowType } = row;

  switch (rowType) {
    case ROW_TYPES.LOAD_MORE:
      return <LoadMoreRow row={row} />;
    case ROW_TYPES.FULL_COLSPAN:
      return <FullColSpanRow row={row} />;

    default:
      return null;
  }
};

export default SpecialRowTypes;
